import React, {Component} from 'react';
//import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import {
    Headline5,
    Headline6,
  //  Subtitle1,
} from '@material/react-typography'
//import BackgroundDashboard from './BackgroundDashboard';
import MagnitudeDashboardChart from '../MagnitudeDashboard/MagnitudeDashboardChart'

import {
          computeOverallFrequencyDist, 
          computeOverallProportionDist,
          computeDimensionCategoryFrequencyDistn,
          computeDimensionCategoryProportionDistn,
          dataIsAvailable,
          computeSortedChartData
        } from '../../service/statsCompute/surveez_stats.js'
import { ThemeContext } from '../../themeContext';


class BackgroundDashboardContainer extends Component {

    static propTypes = {
        // numberOfItemsToFilterFor: PropTypes.number.isRequired,
        // itemsToFilterCol: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            dimension:  Object.keys(this.props.dimensions)[0],
          
        }

      //  this.dashboardData = dashboardData
    }

    _computeFrequency(itemToRank, data) {

        let freq = 0;
        for (let item of data) {
            if (item.includes(itemToRank)) {
                ++freq
            }
        }

        return {
            item: itemToRank,
            noOfRespondents: freq
        }

    }

    computeColumnData(data, colname) {
        if (!data || !colname) return []

        return data.filter((row)=> row[colname] !== undefined).map((datum)=> datum[colname])
    }

    
    render() {

        let slidesToShow = 1.1
        const slideIndex = 0;
        let withoutControls = true
        if (this.props.isMediumScreen) {
            slidesToShow = 2.05
            // withoutControls = false
        }

        if (this.props.isLargeScreen) {
            slidesToShow = 3.05
            withoutControls = false
        }
        
        const theme = this.context.theme;
        const headlineStyle = {
            color: theme.color
        }

        
        const colData = this.computeColumnData(this.props.data, "yearsOfExperience")

        const eduBgColData =  this.computeColumnData(this.props.data, this.props.col.name)
        const overallFreqDist = computeOverallFrequencyDist(this.props.col.categories, eduBgColData)
        const overallProportionDist = computeOverallProportionDist(overallFreqDist, eduBgColData.length).sort((a,b)=> b.percentOfRespondents - a.percentOfRespondents)
     
        const chartData = {
            yvalues: overallProportionDist.map(row=> row.percentOfRespondents),
            xvalues: overallProportionDist.map(row=> row.item),
            yAxisTitle: "Percent Of Respondents",
            handleSelectedDatapoint: ()=>{},
            selectedRankedItem: '',
            children: '',
            className: 'rankAndMagChart home-overallChart',
            chartHeight: '400px',
            colors: ['#ff0266'],
            metricUnit: '%'
        }
        
        let dimensionCategories = []
        
        for (let key in this.props.dimensions[this.state.dimension]) {
            dimensionCategories.push(this.props.dimensions[this.state.dimension][key])
        }       

        const dimensionCategoryProportionDistnTableList = dimensionCategories.map(dimCategory=>{
            const dimensionCategoryDistnTable = computeDimensionCategoryFrequencyDistn(this.props.col.categories, this.state.dimension, dimCategory, this.props.data, this.props.col.name)
            const dimensionCategoryProportionDistnTable = computeDimensionCategoryProportionDistn(dimensionCategoryDistnTable, this.props.data.length)
            
            const sortedChartData = computeSortedChartData(dimensionCategoryProportionDistnTable)

           let chartData = null;

            if (dataIsAvailable(sortedChartData.percentOfRespondents)) {
                 chartData = {
                    yvalues: sortedChartData.percentOfRespondents,
                    xvalues:  sortedChartData.itemsToRank,
                    yAxisTitle: "Percent Of Respondents",
                    handleSelectedDatapoint: ()=>{},
                    selectedRankedItem: '',
                    children: '',
                    className: 'rankAndMagChart',
                    chartHeight: '300px',
                    colors: ['#ff0266'],
                    metricUnit: '%',
                }
                
            } else {
                 chartData = {
                    yvalues: [],
                    xvalues:  sortedChartData.itemsToRank,
                    yAxisTitle: "Percent Of Respondents",
                    handleSelectedDatapoint: ()=>{},
                    selectedRankedItem: '',
                    children: '',
                    className: 'rankAndMagChart',
                    chartHeight: '300px',
                    colors: ['#ff0266'],
                   
                 }
            } 

            return  <MagnitudeDashboardChart key={dimCategory} {...chartData}>
                              <Headline6 className="headline6">{dimCategory}</Headline6>  
                    </MagnitudeDashboardChart>
           
        })
        
        console.dir(dimensionCategoryProportionDistnTableList)
        // compute histogram data
      //  let ar = []
        const histogramData = colData.map(datum=>{
           return [datum]
        })
        histogramData.unshift(["Years Of Experience"])
        console.dir(histogramData)
        // const containerData = {
        //     yvalues: histogramData,
        //     // yvalues: [4, 3, 10, 9, 29, 19, 22, 4, 4],
        //     xvalues: [10,20,30,40,50,60,70],
        //     chartHeight: '300px',
        //     className: "experienceChart",
        //     colors: ['#ff0266'],
        //     yAxisTitle: "Percent Of Respondents",
        //     metricUnit: '%',
        //     handleSelectedDatapoint: ()=>{}
        // }
        
      
        return <div className="rankAndMagnitudeChart-container">
                    <Headline5 className="headline5">{this.props.dashboardTitle}</Headline5>
                    {/* <Subtitle1 className="subtitle1">Select any data point to see the average Time spent</Subtitle1> */}
                    <Headline6 className="headline6" style={headlineStyle}>{this.props.overallChartTitle}</Headline6>
                    {/* <BackgroundDashboard {...containerData} /> */}
                    <MagnitudeDashboardChart  {...chartData}>
                            <Headline6 className="headline6">Overall</Headline6>
                    </MagnitudeDashboardChart>

                    <Headline6 className="headline6" style={headlineStyle}>{this.props.dimensionChartsTitle} {this.props.dimensionLabels[this.state.dimension]} </Headline6>                                    
                    <div className="randAndMagnitudeChart-dimensionChartList">
                    <Carousel key={this.state.dimension} slidesToShow={slidesToShow} cellSpacing={16} slidesToScroll={1} slideIndex={slideIndex} slideWidth={1.0} 
                                dragging swiping withoutControls={withoutControls}>
                        {dimensionCategoryProportionDistnTableList}
                    </Carousel>
                </div>
               </div>
    }

}

BackgroundDashboardContainer.contextType = ThemeContext
export default BackgroundDashboardContainer